/*
  Green Hunters, gh-nav.js
  Navigations-Paket. Aktuell nur die Auto-Rotation der USP-Leiste (Modul A) auf
  Mobil: ein Eintrag sichtbar, Wechsel alle 4 Sekunden. Nur aktiv, solange der
  Mobil-Breakpoint (< 750px) greift UND prefers-reduced-motion NICHT gesetzt ist.
  Auf Desktop zeigt CSS alle Eintraege nebeneinander, die Rotation pausiert.
  Ohne dieses JS bleibt der erste USP-Eintrag sichtbar (CSS-Fallback).
  Als IIFE gewrappt, mit defer geladen, keine Dawn-Datei angefasst.
*/
(function () {
  'use strict';

  var ROTATE_MS = 4000;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobile = window.matchMedia('(max-width: 749px)');
  var bars = document.querySelectorAll('.gh-usp-bar');

  Array.prototype.forEach.call(bars, function (bar) {
    var items = bar.querySelectorAll('.gh-usp-bar__item');
    if (items.length < 2) return;

    bar.classList.add('gh-usp-bar--js');
    var index = 0;
    var timer = null;
    items[0].classList.add('is-active');

    function show(next) {
      items[index].classList.remove('is-active');
      index = (next + items.length) % items.length;
      items[index].classList.add('is-active');
    }

    function start() {
      if (timer || reduce.matches || !mobile.matches) return;
      timer = window.setInterval(function () { show(index + 1); }, ROTATE_MS);
    }

    function stop() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }

    function sync() {
      if (mobile.matches && !reduce.matches) { start(); } else { stop(); }
    }

    mobile.addEventListener('change', sync);
    reduce.addEventListener('change', sync);
    sync();
  });
})();
